export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd122021',
  loginNameProject: 'BIODIGESTOR ARGA - BRUSQUE',
  sideNameProject: 'BIO ARGA',
  exibirGraficoInicial: true,
  iconeInterno: '../static/img/logoBrusque.svg',
  grafico: {
    parametro: 'BiodigestorVazaoAcumulada',
    titulo: 'Gás consumido a partir do dia',
    label: 'Gás consumido (m³)'
  },
  idioma: 'Pt-Br'
}



// WEBPACK FOOTER //
// ./src/config/index.js